import type { Document } from '@getaccept/lib-shared/src/types/Document';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import { DocumentStatus } from '@getaccept/lib-shared/src/enums/document-status';
import type { SearchResult, HighlightedSearchResultItem } from '../types/search-result';
import { MoveDirection } from '../types/enums/move-direction';
import { SearchResultType } from '../types/enums/search-result-type';
import { MathHelper } from '../../../helpers/math.helper';

export class SearchHelper {
  static getDocumentLink(document: Document): string {
    if (
      document?.status === DocumentStatus.Draft ||
      document?.status === DocumentStatus.Importing
    ) {
      return `/document/edit/${document?.id}`;
    }
    return `/document/view/${document?.id}`;
  }

  static getContactLink(contact: User): string {
    return `/contact/show/${contact?.id}`;
  }

  static createHighlight(type: SearchResultType, index: number): HighlightedSearchResultItem {
    return { type, index };
  }

  static moveResultItemHighlight(
    direction: MoveDirection,
    highlightedResultItem: HighlightedSearchResultItem,
    result: SearchResult
  ): HighlightedSearchResultItem {
    const { type, index }: { type: SearchResultType; index: number } = highlightedResultItem;
    const maxDocumentsIndex: number = result[SearchResultType.Documents].length - 1;
    const maxSelectedIndex: number = result[type].length - 1;
    const isFirstContactItem: boolean = type === SearchResultType.Contacts && index === 0;
    const isLastDocumentItem: boolean =
      type === SearchResultType.Documents && index === maxDocumentsIndex;

    switch (direction) {
      case MoveDirection.Up:
        if (isFirstContactItem) {
          return this.createHighlight(SearchResultType.Documents, maxDocumentsIndex);
        }
        return this.createHighlight(type, MathHelper.clamp(index - 1, -1, maxSelectedIndex));
      case MoveDirection.Down:
        if (isLastDocumentItem) {
          return this.createHighlight(SearchResultType.Contacts, 0);
        }
        return { type, index: MathHelper.clamp(index + 1, -1, maxSelectedIndex) };
      case MoveDirection.Left:
        return this.createHighlight(SearchResultType.Documents, 0);
      case MoveDirection.Right:
        return this.createHighlight(SearchResultType.Contacts, 0);
    }
  }
}
